import SessionManager from '../util/SessionManager';
import {
  generateCodeChallenge,
  generateCodeVerifier,
} from './codeChallengeGenerator';
import { createSession } from './createSession';
import generateTokenData from './generateUserToken';
import {
  getTokens,
  getTokensFromCode,
} from '../clients/loginClient-depricated';
import { generateLoginUrl } from './query';
import { ITokenData } from './types';

const VERIFIER_STORAGE_KEY = 'pckeVerifier';

export async function loginWithAuthCode(code: string) {
  // const authorizationState = localStorage.getItem('authorization-state');
  // if (authorizationState !== sessionQuery.state) {
  //   // TODO Middleman attack
  // }

  const codeVerifier = localStorage.getItem(VERIFIER_STORAGE_KEY);
  if (!codeVerifier) {
    throw new Error('Code verifier is missing.');
  }

  const tokens = await getTokensFromCode(code, codeVerifier);
  return generateTokenData(tokens);
}

export async function loginWithRefreshToken() {
  const tokens = await getTokens();
  return generateTokenData(tokens);
}

export async function redirectToLogin(accountId: string) {
  const codeVerifier = generateCodeVerifier();
  localStorage.setItem(VERIFIER_STORAGE_KEY, codeVerifier);

  const url = generateLoginUrl({
    codeChallenge: await generateCodeChallenge(codeVerifier),
    accountId,
  });

  window.location.href = url;
}

export async function logout(sessionManager: SessionManager) {
  localStorage.removeItem(sessionManager._storageKey);
}

export async function login(
  accountId: string,
  authorizationCode: string,
  sessionManager: SessionManager
) {
  let tokenData: ITokenData | undefined;

  try {
    if (authorizationCode) {
      tokenData = await loginWithAuthCode(authorizationCode);
    } else {
      tokenData = await loginWithRefreshToken();
    }

    if (!tokenData) {
      throw new Error('Failed to get tokens.');
    }

    return createSession(tokenData, sessionManager);
  } catch (err) {
    void logout(sessionManager);
    void redirectToLogin(accountId);
    return;
  }
}
